import React from 'react';
import ReactSpeedometer from "react-d3-speedometer";

function EkovillaMeter(props) {

    const currentValue = props.showValue ? "" + props.value.toFixed(1) : "";
    return (
        <div className="flex flex-wrap justify-center">
            <ReactSpeedometer
                width={210}
                height={130}
                maxSegmentLabels={0}
                segments={1000}
                startColor={props.startColor}
                endColor={props.endColor}
                needleColor={'#3D3D3D'}
                needleHeightRatio={0.7}
                currentValueText={currentValue}
                forceRender={true}
                maxValue={props.maxValue}
                minValue={0}
                value={props.value}
            />
        </div>
    )
}

export default EkovillaMeter;